module.exports = __webpack_public_path__ + "media/Register_by_PO.598fadeb.mp4";